import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=6de74ac8&"
import script from "./AboutView.vue?vue&type=script&lang=js&"
export * from "./AboutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports